import { theme_light, theme_dark } from "../commonConstants";

const setTheme = theme => {
    document.body.classList.toggle("dark-theme", theme === theme_dark);
    document.body.classList.toggle("light-theme", theme === theme_light);
};

export default setTheme;
